import Cookies from "js-cookie";

class SmvContrast extends HTMLElement {

  constructor() {
    super();

    this.html = document.documentElement;
    this.indicatorLine = this.querySelector('.indicator-line');
    this.button = this.querySelector('button');
  }


  connectedCallback() {
    // set contrast class from cookie
    this.active = Cookies.get('contrast') == 'active';

    // check prefers-contrast if cookie is not set
    if (typeof Cookies.get('contrast') == 'undefined') {
      const h = matchMedia('(prefers-contrast: more)');
      this.active = h.matches;
      if (this.active) {
        Cookies.set('contrast', 'active');
      }
    }

    this.indicatorLine.classList.toggle('!opacity-0', !this.active);

    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      // toggle active on click
      this.active = !this.active;
    });
  }


  get active() {
    return this.hasAttribute('active');
  }

  set active(val) {
    if (val && val != this.active) {
      this.setAttribute('active', 1);
    } else {
      this.removeAttribute('active');
    }
  }


  static get observedAttributes() {
    return ['active'];
  }

  attributeChangedCallback(name, oldValue, newValue) {
    if (name == 'active') {
      this.html.classList.toggle('contrast', newValue);

      if (this.active) {
        this.indicatorLine.classList.remove('!opacity-0');
        this.button.title = 'Kontrastmodus beenden';
        this.button.ariaLabel = 'Kontrastmodus beenden';
        this.button.ariaPressed = true;
        Cookies.set('contrast', 'active');
      }
      else {
        this.indicatorLine.classList.add('!opacity-0');
        this.button.title = 'Kontrastmodus aktivieren';
        this.button.ariaLabel = 'Kontrastmodus aktivieren';
        this.button.ariaPressed = false;
        Cookies.set('contrast', 'inactive');
      }
    }
  }
}


// Define the new web component
if ('customElements' in window) {
  customElements.define('smv-contrast', SmvContrast);
}
